import { Cell, CellGroup, Field, Button, Popup, Picker } from 'vant'
import { mapState } from 'vuex'

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  name: 'HtCreditCard',
  props: {
    c: Array,
    data: String,
    pickerData: Object
  },
  data() {
    return {
      model_: {
        'orderId': '',
        'number': '',
        'cvv': '',
        'expirationYear': '',
        'expirationMonth': '',
        'holderName': '',
        'idType': '',
        'cardType': '',
        'idNo': '',
        'tel': '',
        'dbJe': 0,
        '_expirationMY': '',
        '_number_error_message': '',
        '_isCVV': false,
        '_typeName': ''
      },
      creditcardValidate_: '',
      cardList: [
        { name: '国内', children: [] },
        { name: '国际', children: [] },
      ],
      cardTypeName: '',
      showCardTypePicker: false
    }
  },
  created () {
    this.getCreditCardList()
  },
  mounted() {
  },
  methods: {
    emitClick() {
      this.model_._typeName = this.pickerData._typeName
      this.model_.idType = this.pickerData.idType

      let msg = ''
      let isValid = true
      if (this.model_._expirationMY) {
        this.model_.expirationMonth = this.model_._expirationMY.split('/')[0]
        this.model_.expirationYear = this.model_._expirationMY.split('/')[1]
      }
      if (!this.model_.cardType) {
        msg = '请选择信用卡类型'
      }
      if (!this.model_.number || this.creditcardValidate_.isValid == '0') {
        msg = '信用卡卡号不能为空/无效'
      }
      if (!this.model_.cvv && this.creditcardValidate_.isNeedVerifyCode == '1') {
        msg = 'CVV不能为空'
      }
      if (!this.model_._typeName) {
        msg = '请选择证件类型'
      }
      if (!this.model_.idNo) {
        msg = '证件号码不能为空'
      }
      if (!this.model_.holderName) {
        msg = '持卡人姓名不能为空'
      }
      if (!this.model_.expirationYear || !this.model_.expirationMonth) {
        msg = '信用卡有效期不能为空/填写有误'
      }
      if (!this.model_.tel || !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.model_.tel))) {
        msg = '手机号不能为空/格式不符合要求'
      }
      if (msg) {
        this.isValid = false
        return this.$toast(msg)
      }
      isValid && this.$emit('ListenChild', this.model_)
    },
    /**
     * 验证信用卡有效性
     */
    creditcardValidate() {
      /**
			 * 初始化
			 */
      this.model_._number_error_message = ''
      this.$api['htQuery/creditcardValidate']({
        singaZhid: this.interfacePlat.singaZhid,
        platZhid: this.interfacePlat.platZhid,
        creditCardNumber: this.model_.number,
        interfacePlatEnum: this.data_._ratePlans.fyid, // 接口供应商标识，列表查询返回的接口供应商标识
      }).then(res => {
        this.creditcardValidate_ = res.data
        /**
         * 信用卡是否可用 1可用 0不可用
         */
        if (res.data.isValid == '0') {
          this.model_._number_error_message = '信用卡卡号无效，请重新输入'
        }
        /**
         * 是否需要提供CVV验证码 1需要 0不需要
         */
        if (res.data.isNeedVerifyCode == '1') {
          this.model_._isCVV = true
        }
      }).catch(() => {})
    },
    
    async getCreditCardList () {
      let { data = {} } = await this.$api['common/getBClass']({ parNo: 14000 })
      let list = data.list || []
      list.forEach((card) => {
        if (card.by3 == '0') {
          this.cardList[1].children.push({
            ...card,
            name: `${card.by2} --- ${card.cName}`
          })
        } else {
          this.cardList[0].children.push({
            ...card,
            name: `${card.by2} --- ${card.cName}`
          })
        }
      })
    },
    showPicker() {
      this.$emit('showPickerMethod')
    },
    onConfirm (names, indexs) {
      let card = this.cardList[indexs[0]].children[indexs[1]]
      this.cardTypeName = card.name
      this.model_.cardType = card.id
      this.showCardTypePicker = false
    }
  },
  computed: mapState({
    /**
     * 酒店详情数据模型
     */
    data_: (state) => state.ht.orderDetails,
    interfacePlat: state => state.ht.interfacePlat,
  }),
}